import React, { useState } from 'react';
import { Popover } from 'antd';
import {
  MdLocationOn,
  MdPhone,
  MdLanguage,
  MdOpenInNew,
} from 'react-icons/md';

const popoverContent = (
  <div className="flex min-w-[16.25rem] flex-col gap-3">
    <div className="flex items-start gap-2">
      <MdLocationOn className="mt-0.5 shrink-0 text-lg text-success" />
      <span className="text-sm text-charcoal">
        Unit 1 / 13-15 Steel Street, Capalaba QLD 4157
      </span>
    </div>
    <div className="flex items-center gap-2">
      <MdPhone className="shrink-0 text-lg text-success" />
      <span className="text-sm text-charcoal">07 3220 2959 | 0407 064 930</span>
    </div>
    <div className="flex items-center gap-2">
      <MdLanguage className="shrink-0 text-lg text-success" />
      <a
        href="https://www.backpaddock.com.au"
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-success underline-offset-2 hover:text-success-dark hover:underline"
      >
        www.backpaddock.com.au
      </a>
    </div>
    <div className="flex items-center gap-2">
      <MdOpenInNew className="shrink-0 text-lg text-success" />
      <a
        href="https://downloads.backpaddock.com.au/OnlineSupport.html"
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-success underline-offset-2 hover:text-success-dark hover:underline"
      >
        Helpdesk Online
      </a>
    </div>
  </div>
);

const ContactSupport: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      content={popoverContent}
      title="Contact Support"
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="top"
    >
      <button
        type="button"
        className="text-sm text-secondary-dark underline-offset-2 hover:text-success hover:underline"
      >
        Or contact support...
      </button>
    </Popover>
  );
};

export default ContactSupport;
